export default 'icon--menu';